import React from "react";
import PropTypes from "prop-types";

import "./TabFooter.styl";

const propTypes = {};

function TabFooter({ children, ...props }) {
  return (
    <div className="footer" {...props}>
      {children}
    </div>
  );
}

TabFooter.propTypes = propTypes;

export { TabFooter };
